import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Estilos globales
import "leaflet/dist/leaflet.css";

// Componentes de Estructura
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from "./components/ScrollToTop";
import ScrollOnHome from "./components/ScrollOnHome";

// Vistas / Páginas
import CataloguePage from './components/CataloguePage';
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import Benefits from "./components/Benefits";
import HomeServices from "./components/HomeServices";
import WorkGallery from "./components/WorkGallery";
import FeaturedProducts from "./components/FeaturedProducts";
import LeafletCoverageMap from "./components/LeafletCoverageMap";
import ServiceScope from './components/ServiceScope';

import { Analytics } from "@vercel/analytics/react";

// --- NUEVA PROTECCIÓN DE IMÁGENES ---
const SecurityHandler = () => {
    const location = useLocation();

    useEffect(() => {
        // Condición: Si NO estamos en el catálogo, protegemos el contenido
        const isCatalogue = location.pathname.startsWith('/catalogo');

        const preventActions = (e) => {
            if (!isCatalogue) {
                // Bloquea clic derecho
                if (e.type === 'contextmenu') e.preventDefault();
                // Bloquea arrastrar imágenes (muy común en laptops)
                if (e.type === 'dragstart' && e.target.tagName === 'IMG') e.preventDefault();
            }
        };

        // Aplicamos los eventos al documento
        document.addEventListener('contextmenu', preventActions);
        document.addEventListener('dragstart', preventActions);

        return () => {
            document.removeEventListener('contextmenu', preventActions);
            document.removeEventListener('dragstart', preventActions);
        };
    }, [location]);

    return null; // Este componente no renderiza nada, solo ejecuta la lógica
};

const LandingPage = () => (
    <>
        <Hero />
        <AboutUs />
        <LeafletCoverageMap />
        <Benefits />
        <ServiceScope />
        <HomeServices />
        <FeaturedProducts />
        <WorkGallery />
    </>
);

function App() {
    const isMaintenanceMode = false;

    useEffect(() => {
        AOS.init({
            once: true,
            duration: 1000,
            easing: 'ease-out',
            disable: 'mobile'
        });
    }, []);

    if (isMaintenanceMode) {
        return (
            <div style={{
                textAlign: 'center',
                marginTop: '20%',
                fontFamily: 'sans-serif',
                padding: '20px'
            }}>
                <h1 style={{color: '#d32f2f'}}>Sitio en Mantenimiento Administrativo</h1>
                <p style={{fontSize: '1.2rem', color: '#555'}}>
                    La plataforma de <strong>C-TEX Mantenimiento Integral</strong> se encuentra temporalmente fuera de servicio.
                </p>
                <p>Lamentamos los inconvenientes. El servicio se restablecerá a la brevedad.</p>
            </div>
        );
    }

    return (
        <Router>
            <SecurityHandler />

            <div className="App min-h-screen flex flex-col font-sans antialiased">
                <Header />

                <main className="flex-grow">
                    <ScrollToTop />
                    <ScrollOnHome />

                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/catalogo" element={<CataloguePage />} />
                        <Route path="/catalogo/:productId" element={<CataloguePage />} />
                        <Route path="*" element={<LandingPage />} />
                    </Routes>
                </main>

                <Footer />
            </div>
            <Analytics />
        </Router>
    );
}

export default App;
